import React from "react";

//import Button from "../shared/Button";

const FolderToolbar = props => (
  <div className="folder__toolbar">
    {/*
    <Button
      onClick={props.openDownloadFolderModal}
      additionalClassName="folder__toolbar-item button--icon"
      icon="button__icon--download i-download"
    />
    <Button
      onClick={props.handleDeleteFolder}
      // onClick={() => handleDeleteFolder({ id })}
      additionalClassName="folder__toolbar-item button--icon"
      icon="button__icon--trash i-trash"
    />
     <Button
      className="folder__toolbar-item"
      label="Télécharger"
     icon="i-arrow-right-light"
     />
 */}
  </div>
);

export default FolderToolbar;



// WEBPACK FOOTER //
// ./src/components/account/FolderToolbar.js